







































































import {Component, Vue} from 'vue-property-decorator';
import Game from '@/classes/Game';
import Cell from "@/classes/Cell";
import CellCollection from "@/classes/CellCollection";
import {uniq} from 'lodash';

@Component({
    components: {},
})
export default class App extends Vue {
    game: Game = new Game();
    current_cell?: Cell;

    shuffle() {
        this.game.shuffle();
    }

    removeEmpties() {
        this.game.removeEmpties();
        this.game.adjustWidth()
    }

    handleClick(evt: any, cell: Cell) {
        if (cell.is_solved) {
            return;
        }

        if (this.current_cell === cell) {
            this.current_cell.is_selected = false;
            this.current_cell = undefined;

            return;
        }

        if (this.current_cell) {
            this.current_cell.is_selected = false;
            const neighbors = this.game.getNeighbors(this.current_cell);

            for (let i = 0; i < neighbors.length; i++) {
                if (neighbors[i].cell === cell) {
                    if (this.game.matchPair(cell, this.current_cell)) {
                        const solved_rows = [
                            this.game.getRowFor(cell),
                            this.game.getRowFor(this.current_cell),
                        ].filter(collection => collection.isSolved());
                        const solved_columns = [
                            this.game.getColumnFor(cell),
                            this.game.getColumnFor(this.current_cell)
                        ].filter(collection => collection.isSolved());

                        this.game.width -= solved_columns.length;

                        uniq(solved_rows.concat(solved_columns).flatMap(collection => collection.cells))
                            .forEach(cell => this.game.removeCell(cell))

                        this.current_cell = undefined;

                        return;
                    }
                    break;
                }
            }
        }

        cell.is_selected = true;

        this.current_cell = cell;
    }

    get widthIsEven(): boolean {
        return this.game.width % 2 === 0;
    }

    formatCell(cell: Cell, index: number): string {

        const classes = ['shadow-inner'];

        if (cell.is_solved) {
            classes.push('bg-gray-400', 'text-gray-600');
        } else if (cell.is_selected) {
            classes.push('bg-purple-300', 'text-purple-800');
        } else {
            classes.push('text-yellow-400', 'cursor-pointer');
            classes.push(((index + (this.widthIsEven ? Math.floor(index / this.game.width) : 0)) % 2) ? 'bg-gray-800' : 'bg-teal-800');
        }

        return classes.join(' ');
    }

    mounted() {
        this.game.width = 10;
        this.game.addRandomCells(100);
        this.game.adjustWidth();
    }
}
